import { http, HttpResponse } from 'msw';
import { usersMocks } from '../mocks';

export const staff = http.get('*/users/admin/:useId/staff', () =>
  HttpResponse.json(usersMocks.staff)
);
